import React, { useEffect, useState } from "react";
import { AppLayout } from "../../../layouts";
import { Header, NavAndTabs, Sides } from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DiagnosticReportTab from "./diagnosticReportTab";
import PatientInformationAndSymptoms from "./patientInformationAndSymptoms";
import DiagnosticHistory from "./diagnosticHistory";
import { useDispatch } from "react-redux";
import { actionDoctor } from "../../../redux/actions";
import { useTranslation } from "react-i18next";

const DiagnosticReport = ({ loginData }) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const appointment = location.state?.appointment;
    const appointmentStatus = location.state?.appointmentStatus;

    const [activeTab, setActiveTab] = useState(
        id || "patient-information-and-symptoms"
    );
    const onTabChange = (tabId) => {
        setActiveTab(tabId);
        navigate(
            `/doctor/diagnostic-report/${tabId}`,
            {
                state: { appointment },
            }
        );
    };

    useEffect(() => {
        dispatch(
            actionDoctor.getDiagnosticById(appointment?.appointmentGuid, loginData?.currencyCode)
        );
        dispatch(
            actionDoctor.getAllAppointmentDetail(
                appointment?.appointmentGuid,
                loginData?.currencyCode,
                false
            )
        );
        dispatch(actionDoctor.getAllAdditionalServices(loginData?.userGuid, loginData?.currencyCode));
        dispatch(
            actionDoctor.getAdditionalServiceInfo(appointment?.appointmentGuid, loginData?.currencyCode)
        );
        dispatch(
            actionDoctor.getAllAppointmentDetailList(
                appointment?.appointmentGuid,
                loginData?.currencyCode,
                false
            )
        );
    }, [appointment?.appointmentGuid, dispatch, loginData?.currencyCode, loginData?.userGuid]);

    const tabs = [
        {
            id: "patient-information-and-symptoms",
            label: t("doctor.diagnostic_report.patient_information_&_symptoms"),
            content: <PatientInformationAndSymptoms loginData={loginData} />,
            disabled: false,
        },
        {
            id: "diagnostic-report",
            label: t("Diagnostic_Report"),
            content: (
                <DiagnosticReportTab
                    loginData={loginData}
                    appointment={appointment}
                    appointmentStatus={appointmentStatus}
                />
            ),
            disabled: false,
        },
        {
            id: "diagnostic-history",
            label: t("doctor.diagnostic_report.diagnostic_history"),
            content: <DiagnosticHistory />,
            disabled: false,
        },
    ].filter((tab) => {
        if (appointmentStatus === 2) {
            return tab.id === "diagnostic-report";
        }
        return true;
    });

    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage
                        pageHeading={`${t("Diagnostic_Report")} / ${tabs.find((tab) => tab.id === activeTab)?.label || `${t("Diagnostic_Report")}`}`}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <NavAndTabs.NavAndTabs
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={onTabChange}
                    />
                </Col>
            </Row>
        </Container>
    );
    return (
        <>
            <AppLayout.AppLayoutOne
                leftSide={<Sides.LeftSides loginData={loginData} />}
                rightSide={rightSide}
            />
        </>
    );
};

export default DiagnosticReport;
